import { render, staticRenderFns } from "./MessengerContactList.vue?vue&type=template&id=2db48c60&scoped=true"
import script from "./MessengerContactList.vue?vue&type=script&lang=js"
export * from "./MessengerContactList.vue?vue&type=script&lang=js"
import style0 from "./MessengerContactList.vue?vue&type=style&index=0&id=2db48c60&prod&lang=scss"
import style1 from "./MessengerContactList.vue?vue&type=style&index=1&id=2db48c60&prod&scoped=true&lang=scss"
import style2 from "./MessengerContactList.vue?vue&type=style&index=2&id=2db48c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db48c60",
  null
  
)

export default component.exports